import { render, staticRenderFns } from "./ApoiadoUsuario.vue?vue&type=template&id=3216cb36&"
import script from "./ApoiadoUsuario.vue?vue&type=script&lang=js&"
export * from "./ApoiadoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports